export default __webpack_public_path__ + "static/media/pes_voditkobarva-min.9d636b59.png";